import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  categoryHeader: 'Category',
  nameHeader: 'Item',
  priceHeader: 'Price',
  skuLabel: 'SKU: {sku}',
})
